import React from 'react';
import './change_pass_success.css';
import { Link } from 'react-router-dom';
import '../index.css';
import './login.css';



const ChangePassSuccess = () => {

  return (
      <div className="pass-success container-sm">
          <div>
          <div className="d-flex justify-content-center ">
        <h3 data-testid="success-message"className="h4 green ">Password telah berhasil diupdate</h3>

        </div>
        <div className="d-flex justify-content-center">
            <Link to="/" className="text-decoration-none login">
            <button className="button-logout button" >
                    Home
            </button>
            </Link>
        </div>
          </div>
      </div>
  );
}

export default ChangePassSuccess

